import React, { useEffect, useRef, useState } from "react";
import DataTable from "react-data-table-component";
import {
    ChevronDown,
    Trash,
    Eye,
    RefreshCw,
    Search,
    X
} from "react-feather";

import {
    Card,
    CardBody,
    CardHeader,
    Col,
    Row,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter
} from "reactstrap";

import "assets/css/react-dataTable.scss";
import { useTranslation } from "react-i18next";

import {
    getIconComponentByCaller,
    getIndexTableByType,
    getTextUrlClean,
    isSolarPhotovoltaicByCaller,
    isSolarThermalByCaller,
    isThermalByCaller,
    isWaterByCaller
} from "utils/Types";

import { Input } from "antd";

import {
    deleteUserPlant,
    getUserPlants
} from "utils/Requests/Plant";

import LoadingBar from "react-top-loading-bar";
import { removeBlurButton } from "utils/Buttons";
import { getValue } from "utils/Forms";
import { useLocation, useNavigate } from "react-router-dom";
import { SearchAlert } from "components/Alerts";

import {
    DataTableError,
    DataTableNoRecords,
    DataTableLoader
} from "components/Table/PlantsTableCommon";

import { CardOverlayLoader } from "../Cards/CardOverlayLoader";
import i18next from "i18next";

import {
    globalStatusOptions,
    StatusInput
} from "components/Forms/Inputs/EventsInput";

import config from "/app/src/config.js";
import { getStatusSelected } from "../Badge/BadgeGlobalStatusSummary";


const _ = require("lodash");

const isMobileOnly = config.mbl_version;

const defaultPaginationPerPage = 20;
const defaultPaginationNumber = [10, 15, 20, 25, 30];


/*
 * ============================================================
 * DELETE MODE STORAGE
 * ============================================================
 */

const DELETE_MODE_STORAGE_KEY = "seye.deleteMode";


const isDeleteModeActive = () => {
    return (
        sessionStorage.getItem(
            DELETE_MODE_STORAGE_KEY
        ) === "1"
    );
};


const setDeleteModeActive = (value) => {

    if (value) {

        sessionStorage.setItem(
            DELETE_MODE_STORAGE_KEY,
            "1"
        );

    } else {

        sessionStorage.removeItem(
            DELETE_MODE_STORAGE_KEY
        );
    }
};


/*
 * ============================================================
 * TABLE / FILTER STORAGE
 * ============================================================
 */

const getPlantsBadgeStatusStorageKey = (props) =>
    `seye.plantsBadgeStatus.${props.caller}`;


const getPlantsTableStorageKey = (props) =>
    `seye.plantsTable.${props.caller}`;


const getPlantsStatusStorageKey = (props) =>
    `seye.plantsStatus.${props.caller}`;


const getPlantsFilterClearedKey = (props) =>
    `seye.plantsFilterCleared.${props.caller}`;


const getSavedPlantsTableConfig = (
    props,
    defaultSearches = {}
) => {

    try {

        const saved =
            sessionStorage.getItem(
                getPlantsTableStorageKey(
                    props
                )
            );


        if (!saved) {
            return null;
        }


        const parsed =
            JSON.parse(saved);


        return {

            sort:
                parsed.sort ?? {
                    column: "plant_name",
                    direction: "ASC"
                },

            pagination:
                parsed.pagination ?? {
                    perPage:
                        defaultPaginationPerPage,

                    page:
                        1
                },

            search:
                parsed.search ??
                defaultSearches
        };

    } catch (e) {

        return null;
    }
};


const savePlantsTableConfig = (
    props,
    tableConfig
) => {

    sessionStorage.setItem(
        getPlantsTableStorageKey(
            props
        ),
        JSON.stringify(
            tableConfig
        )
    );
};


const clearPlantsTableConfig = (props) => {

    sessionStorage.removeItem(
        getPlantsTableStorageKey(
            props
        )
    );
};


const savePlantsStatusSelected = (
    props,
    statusNameField,
    statusSelected
) => {

    if (
        !statusNameField ||
        !statusSelected
    ) {
        return;
    }


    sessionStorage.setItem(
        getPlantsStatusStorageKey(
            props
        ),
        JSON.stringify({
            field:
                statusNameField,

            value:
                statusSelected
        })
    );
};


const getSavedPlantsStatusSelected = (props) => {

    try {

        const saved =
            sessionStorage.getItem(
                getPlantsStatusStorageKey(
                    props
                )
            );


        return saved
            ? JSON.parse(saved)
            : null;

    } catch (e) {

        return null;
    }
};


const clearPlantsStatusSelected = (props) => {

    sessionStorage.removeItem(
        getPlantsStatusStorageKey(
            props
        )
    );
};


const setPlantsFilterCleared = (
    props,
    value
) => {

    if (value) {

        sessionStorage.setItem(
            getPlantsFilterClearedKey(
                props
            ),
            "1"
        );

    } else {

        sessionStorage.removeItem(
            getPlantsFilterClearedKey(
                props
            )
        );
    }
};


const isPlantsFilterCleared = (props) => {

    return (
        sessionStorage.getItem(
            getPlantsFilterClearedKey(
                props
            )
        ) === "1"
    );
};


/*
 * ============================================================
 * DESKTOP SEARCH FORM
 * ============================================================
 */

const DesktopForm = (props) => {

    const { t } =
        useTranslation();


    const {
        statusNameField,
        formData,
        handleInputChange,
        handlerSearch,
        handleSelectChange
    } = props;


    return (
        <>

            <Col
                xxl="8"
                xl="8"
                lg="12"
                md="12"
                style={{
                    paddingLeft: 0
                }}
            >

                <div className="mb-1">

                    <Input
                        placeholder={
                            t(
                                "searches.placeholders.location_or_name"
                            )
                        }
                        value={
                            formData
                                .search_plant_name_or_address
                        }
                        name="search_plant_name_or_address"
                        onChange={
                            handleInputChange
                        }
                        onPressEnter={
                            handlerSearch
                        }
                    />

                </div>

            </Col>


            <Col
                xxl="4"
                xl="4"
                lg="12"
                md="12"
                style={{
                    paddingLeft: 0
                }}
            >

                <div className="mb-1 d-flex justify-content-between">

                    <StatusInput
                        loading={
                            formData.isLoading
                        }
                        options={
                            _.reject(
                                globalStatusOptions,
                                {
                                    id:
                                        "offer_pending_approval"
                                }
                            )
                        }
                        disabled={
                            formData.isDisabled
                        }
                        value={
                            formData[
                                statusNameField
                            ] ?? []
                        }
                        name={
                            statusNameField
                        }
                        onChange={
                            handleSelectChange
                        }
                        label={
                            t(
                                "searches.placeholders.status"
                            )
                        }
                    />


                    <div className="ms-1">

                        <Button
                            outline
                            onClick={
                                handlerSearch
                            }
                            color="primary"
                            size="sm"
                            style={{
                                padding:
                                    "0.5rem 0.5rem"
                            }}
                        >

                            <Search
                                size={15}
                            />

                        </Button>

                    </div>


                    <div
                        style={{
                            marginLeft:
                                "5px"
                        }}
                    >

                        <Button
                            outline
                            onClick={
                                handlerSearch
                            }
                            color="secondary"
                            size="sm"
                            style={{
                                padding:
                                    "0.5rem 0.5rem"
                            }}
                        >

                            <RefreshCw
                                size={15}
                            />

                        </Button>

                    </div>

                </div>

            </Col>

        </>
    );
};


/*
 * ============================================================
 * MOBILE SEARCH FORM
 * ============================================================
 */

const MobileForm = (props) => {

    const { t } =
        useTranslation();


    const {
        formData,
        handleInputChange,
        handlerSearch
    } = props;


    return (
        <>

            <Col
                xxl="4"
                xl="4"
                lg="12"
                md="12"
                style={{
                    paddingLeft: 0
                }}
            >

                <div className="mb-1 d-flex justify-content-between">

                    <Input
                        placeholder={
                            t(
                                "searches.placeholders.location_or_name"
                            )
                        }
                        value={
                            formData
                                .search_plant_name_or_address
                        }
                        name="search_plant_name_or_address"
                        onChange={
                            handleInputChange
                        }
                        onPressEnter={
                            handlerSearch
                        }
                    />


                    <div className="ms-1">

                        <Button
                            outline
                            onClick={
                                handlerSearch
                            }
                            color="primary"
                            size="sm"
                            style={{
                                padding:
                                    "0.5rem 0.5rem"
                            }}
                        >

                            <Search
                                size={15}
                            />

                        </Button>

                    </div>

                </div>

            </Col>

        </>
    );
};


/*
 * ============================================================
 * SEARCH FORM
 * ============================================================
 */

const SearchPlantForm = ({
    ...props
}) => {

    const {
        configuration,
        searches,
        deleteMode
    } = props;


    const {
        fields
    } = configuration;


    const {
        status:
            statusNameField
    } = fields;


    const [
        formData,
        setFormData
    ] = useState({

        isLoading:
            true,

        isDisabled:
            true
    });


    useEffect(() => {

        setFormData({

            isDisabled:
                false,

            isLoading:
                false,

            ...(searches || {})
        });

    }, [searches]);


    const handleInputChange =
        event => {

            const obj = {

                ...formData,

                [event.target.name]:
                    getValue(event)
            };


            if (
                !getValue(event)
            ) {

                delete obj[
                    event.target.name
                ];
            }


            setFormData(
                obj
            );
        };


    const handleSelectChange =
        (name, value) => {

            const obj = {

                ...formData,

                [name]:
                    value,

                plant_manual_status:
                    -1
            };


            if (
                value.length < 1
            ) {

                delete obj[name];

                delete obj
                    .plant_manual_status;
            }


            setFormData(
                obj
            );
        };


    const handlerSearch =
        () => {

            props.handlerSearch(
                _.omit(
                    formData,
                    [
                        "isLoading",
                        "isDisabled"
                    ]
                )
            );
        };


    const handlerSearchRemove =
        () => {

            setFormData({});

            props
                .handlerSearchRemove();
        };


    return (
        <>

            <Row
                className="mt-1 mb-0 grid-form"
                disabled
                style={{
                    paddingLeft:
                        "15px"
                }}
            >

                {!isMobileOnly
                    ? (

                        <DesktopForm
                            deleteMode={
                                deleteMode
                            }
                            statusNameField={
                                statusNameField
                            }
                            formData={
                                formData
                            }
                            setFormData={
                                setFormData
                            }
                            handleInputChange={
                                handleInputChange
                            }
                            handlerSearch={
                                handlerSearch
                            }
                            handleSelectChange={
                                handleSelectChange
                            }
                        />

                    )
                    : (

                        <MobileForm
                            deleteMode={
                                deleteMode
                            }
                            statusNameField={
                                statusNameField
                            }
                            formData={
                                formData
                            }
                            setFormData={
                                setFormData
                            }
                            handleInputChange={
                                handleInputChange
                            }
                            handlerSearch={
                                handlerSearch
                            }
                            handleSelectChange={
                                handleSelectChange
                            }
                        />

                    )
                }

            </Row>


            {(
                !isMobileOnly &&
                !_.isEmpty(
                    props.searches
                )
            ) && (

                <SearchAlert
                    handler={
                        handlerSearchRemove
                    }
                />
            )}

        </>
    );
};


/*
 * ============================================================
 * ROW ACTION MENU
 * ============================================================
 */

export function TableIconsRowMenu({
    ...props
}) {

    return (
        <>

            <span className="table-row-menu">

                <Eye
                    onClick={() =>
                        props.showHandler(
                            props.row
                        )
                    }
                    className="icon-me"
                />

                <Trash
                    onClick={() =>
                        props.trashHandler(
                            props.row
                        )
                    }
                />

            </span>

        </>
    );
}


/*
 * ============================================================
 * PLANTS TABLE
 * ============================================================
 */

export function PlantsTable({
    ...props
}) {

    const { t } =
        useTranslation();


    const location =
        useLocation();

    const navigate =
        useNavigate();


    const dataTableContainerReference =
        useRef();

    const loadingBarReference =
        useRef();


    /*
     * ========================================================
     * DELETE MODE
     * ========================================================
     *
     * El modo eliminar puede llegar por:
     *
     * 1. props.deleteMode
     * 2. location.state.deleteMode
     * 3. sessionStorage
     *
     * sessionStorage es lo que permite cambiar entre
     * Solar térmica, FV, Agua y Temperatura sin perderlo.
     */

    const [
        deleteMode,
        setDeleteMode
    ] = useState(

        props.deleteMode === true ||

        location.state?.deleteMode ===
            true ||

        isDeleteModeActive()
    );


    /*
     * Si llegamos desde el botón "Eliminar"
     * guardamos también el estado global.
     *
     * Si entramos en otro listado sin state,
     * recuperamos el modo desde sessionStorage.
     */
    useEffect(() => {

        if (
            location.state?.deleteMode ===
            true
        ) {

            setDeleteModeActive(
                true
            );

            setDeleteMode(
                true
            );

            return;
        }


        if (
            isDeleteModeActive()
        ) {

            setDeleteMode(
                true
            );
        }

    }, [
        location.state?.deleteMode
    ]);


    /*
     * CANCELAR MODO ELIMINAR
     *
     * Este es el ÚNICO sitio que apaga
     * el modo global de eliminación.
     */
    const exitDeleteMode = () => {

        /*
         * 1. Borrar persistencia global
         */
        setDeleteModeActive(
            false
        );


        /*
         * 2. Actualizar componente
         */
        setDeleteMode(
            false
        );


        /*
         * 3. Quitar deleteMode del state
         * de React Router.
         */
        const cleanState = {

            ...(location.state || {})
        };


        delete cleanState
            .deleteMode;


        navigate(".", {

            replace:
                true,

            state:
                cleanState
        });
    };


    /*
     * ========================================================
     * FILTER STATUS
     * ========================================================
     */

    const [
        ignoreStatusSelected,
        setIgnoreStatusSelected
    ] = useState(false);


    const {
        value:
            statusSelectedFromLocation,

        field:
            statusNameField
    } = getStatusSelected(
        props,
        location
    );


    const filterCleared =
        isPlantsFilterCleared(
            props
        );


    const savedStatus =
        getSavedPlantsStatusSelected(
            props
        );


    const savedTableConfig =
        getSavedPlantsTableConfig(
            props,
            {}
        );


    const statusSelected =
        location.state
            ?.clearPlantsFilter
            ? null

            : (
                ignoreStatusSelected ||
                filterCleared
            )
                ? null

                : (
                    statusSelectedFromLocation ||
                    savedStatus?.value
                );


    if (
        location.state
            ?.clearPlantsFilter
    ) {

        clearPlantsTableConfig(
            props
        );

        clearPlantsStatusSelected(
            props
        );

        setPlantsFilterCleared(
            props,
            true
        );
    }


    const savedSearch =
        savedTableConfig
            ?.search ??
        {};


    const initialSearches =
        !_.isEmpty(
            savedSearch
        )
            ? savedSearch

            : (
                statusSelected
                    ? {
                        [statusNameField]:
                            statusSelected
                    }

                    : {}
            );


    const initialTableConfig =
        savedTableConfig
            ? {

                ...savedTableConfig,

                search:
                    initialSearches
            }

            : {

                sort: {

                    column:
                        "plant_name",

                    direction:
                        "ASC"
                },

                pagination: {

                    perPage:
                        defaultPaginationPerPage,

                    page:
                        1
                },

                search:
                    initialSearches
            };


    /*
     * ========================================================
     * CONFIGURATION
     * ========================================================
     */

    const [
        configuration,
        setConfiguration
    ] = useState({

        ...props,

        rows:
            [],

        isLoading:
            true,

        message:
            <DataTableNoRecords />,

        totalRows:
            0,

        disabled:
            true,

        tableConfig:
            initialTableConfig,

        paginationOption: {

            rowsPerPageText:
                t(
                    "pagination.rows_per_page"
                ),

            rangeSeparatorText:
                t(
                    "pagination.page_separator"
                ),

            selectAllRowsItem:
                false,

            selectAllRowsItemText:
                t(
                    "pagination.all"
                )
        },

        modal: {

            open:
                false,

            selected:
                {}
        },

        fields: {

            status:
                statusNameField
        }
    });


    /*
     * ========================================================
     * TRANSLATION
     * ========================================================
     */

    const translateEffectDependency =
        t(
            "plant.daily_status"
        );


    useEffect(() => {

        setConfiguration(
            currentConfiguration => {

                if (
                    currentConfiguration
                        .isLoading
                ) {
                    return (
                        currentConfiguration
                    );
                }


                return {

                    ...currentConfiguration,

                    paginationOption: {

                        rowsPerPageText:
                            i18next.t(
                                "pagination.rows_per_page"
                            ),

                        rangeSeparatorText:
                            i18next.t(
                                "pagination.page_separator"
                            ),

                        selectAllRowsItem:
                            true,

                        selectAllRowsItemText:
                            i18next.t(
                                "pagination.all"
                            )
                    }
                };
            }
        );

    }, [
        translateEffectDependency
    ]);


    /*
     * ========================================================
     * REQUEST ROWS
     * ========================================================
     */

    useEffect(() => {

        let isMounted =
            true;


        if (
            !configuration
                .isLoading
        ) {
            return;
        }


        const requestRows =
            () => {

                removeBlurButton(
                    dataTableContainerReference
                        .current
                ).then(
                    () => {}
                );


                if (
                    !configuration
                        .isLoading &&
                    loadingBarReference
                        .current
                ) {

                    loadingBarReference
                        .current
                        .continuousStart();
                }


                /*
                 * Siempre utilizamos el listado
                 * normal del tipo de SEYE.
                 */
                getUserPlants(

                    {
                        ...configuration,

                        ...configuration
                            .tableConfig
                    },

                    response => {

                        if (
                            !isMounted
                        ) {
                            return null;
                        }


                        setConfiguration({

                            ...configuration,

                            rows:
                                response
                                    .data
                                    .plants,

                            isLoading:
                                false,

                            message:
                                <DataTableNoRecords />,

                            totalRows:
                                response
                                    .data
                                    .total,

                            disabled:
                                false
                        });


                        if (
                            loadingBarReference
                                .current
                        ) {

                            loadingBarReference
                                .current
                                .complete();
                        }


                        return null;
                    },

                    () => {

                        if (
                            !isMounted
                        ) {
                            return null;
                        }


                        setConfiguration({

                            ...configuration,

                            rows:
                                [],

                            isLoading:
                                false,

                            message:
                                <DataTableError />,

                            disabled:
                                false
                        });


                        if (
                            loadingBarReference
                                .current
                        ) {

                            loadingBarReference
                                .current
                                .complete();
                        }


                        return null;
                    }
                );
            };


        requestRows();


        return () => {

            isMounted =
                false;
        };

    }, [
        configuration
    ]);


    /*
     * ========================================================
     * STATUS FILTER
     * ========================================================
     */

    useEffect(() => {

        if (
            configuration
                .isLoading
        ) {
            return;
        }

        if (
            ignoreStatusSelected
        ) {
            return;
        }

        if (
            filterCleared
        ) {
            return;
        }

        if (
            !statusSelected
        ) {
            return;
        }


        const currentValue =
            _.get(

                configuration
                    .tableConfig
                    .search,

                statusNameField
            );


        if (
            _.isEqual(
                currentValue,
                statusSelected
            )
        ) {

            savePlantsStatusSelected(
                props,
                statusNameField,
                statusSelected
            );

            return;
        }


        const searches =
            _.omit(

                configuration
                    .tableConfig
                    .search,

                [
                    "plant_daily_alert_id",
                    "plant_hourly_alert_id",
                    "plant_status_id",
                    "plant_manual_status"
                ]
            );


        savePlantsStatusSelected(
            props,
            statusNameField,
            statusSelected
        );


        if (
            [
                "plant_daily_alert_id",
                "plant_hourly_alert_id",
                "plant_status_id"
            ].includes(
                statusNameField
            )
        ) {

            handlerSearch({

                ...searches,

                [statusNameField]:
                    statusSelected,

                plant_manual_status:
                    -1
            });

        } else {

            handlerSearch({

                ...searches,

                [statusNameField]:
                    statusSelected
            });
        }

    }, [
        statusSelected,
        statusNameField,
        ignoreStatusSelected,
        filterCleared
    ]);


    /*
     * ========================================================
     * CLEAR FILTER
     * ========================================================
     */

    useEffect(() => {

        if (
            !location.state
                ?.clearPlantsFilter
        ) {
            return;
        }


        setIgnoreStatusSelected(
            true
        );


        clearPlantsTableConfig(
            props
        );


        clearPlantsStatusSelected(
            props
        );


        setPlantsFilterCleared(
            props,
            true
        );


        setConfiguration(
            currentConfiguration => ({

                ...currentConfiguration,

                disabled:
                    true,

                isLoading:
                    true,

                tableConfig: {

                    ...currentConfiguration
                        .tableConfig,

                    pagination: {

                        perPage:
                            currentConfiguration
                                .tableConfig
                                .pagination
                                .perPage,

                        page:
                            1
                    },

                    search:
                        {}
                }
            })
        );


        navigate(".", {

            replace:
                true,

            state:
                {}
        });

    }, [
        location.state
            ?.clearPlantsFilter
    ]);


    /*
     * ========================================================
     * SELECT STATUS AGAIN
     * ========================================================
     */

    useEffect(() => {

        if (
            !location.state
                ?.status
        ) {
            return;
        }


        setIgnoreStatusSelected(
            false
        );


        setPlantsFilterCleared(
            props,
            false
        );

    }, [
        location.state?.status
    ]);


    /*
     * ========================================================
     * SHOW PLANT
     * ========================================================
     */

    const handlerShow =
        row => {

            if (deleteMode) {
                return;
            }


            const state = {

                ...(location.state || {}),

                plantsTable:
                    configuration
                        .tableConfig,

                plantsStatus:
                    getSavedPlantsStatusSelected(
                        props
                    )
            };


            /*
             * No propagamos deleteMode
             * al detalle.
             */
            delete state
                .deleteMode;


            if (
                isSolarThermalByCaller(
                    configuration
                )
            ) {

                navigate(
                    `/dashboard/plants/thermal/${row.id}-${getTextUrlClean(row.plant_name)}`,
                    {
                        state
                    }
                );

            } else if (
                isSolarPhotovoltaicByCaller(
                    configuration
                )
            ) {

                navigate(
                    `/dashboard/plants/photovoltaic/${row.id}-${getTextUrlClean(row.plant_name)}`,
                    {
                        state
                    }
                );

            } else if (
                isThermalByCaller(
                    configuration
                )
            ) {

                navigate(
                    `/dashboard/plants/temperature/${row.id}-${getTextUrlClean(row.plant_name)}`,
                    {
                        state
                    }
                );

            } else if (
                isWaterByCaller(
                    configuration
                )
            ) {

                navigate(
                    `/dashboard/plants/water/${row.id}-${getTextUrlClean(row.plant_name)}`,
                    {
                        state
                    }
                );
            }
        };


    /*
     * ========================================================
     * RELOAD
     * ========================================================
     */

    const persistAndReload =
        tableConfig => {

            savePlantsTableConfig(
                props,
                tableConfig
            );


            const selectedValue =
                _.get(

                    tableConfig.search,

                    statusNameField
                );


            if (
                selectedValue
            ) {

                setPlantsFilterCleared(
                    props,
                    false
                );


                savePlantsStatusSelected(
                    props,
                    statusNameField,
                    selectedValue
                );


                setIgnoreStatusSelected(
                    false
                );
            }


            setConfiguration({

                ...configuration,

                disabled:
                    true,

                isLoading:
                    true,

                tableConfig
            });
        };


    /*
     * ========================================================
     * SORT
     * ========================================================
     */

    const handlerSort =
        (
            column,
            sortDirection
        ) => {

            persistAndReload({

                ...configuration
                    .tableConfig,

                sort: {

                    column:
                        column.sortField,

                    direction:
                        sortDirection
                }
            });
        };


    /*
     * ========================================================
     * PAGINATION
     * ========================================================
     */

    const handlePageChange =
        page => {

            persistAndReload({

                ...configuration
                    .tableConfig,

                pagination: {

                    perPage:
                        configuration
                            .tableConfig
                            .pagination
                            .perPage,

                    page
                }
            });
        };


    const handlePerRowsChange =
        (
            perPage,
            page
        ) => {

            persistAndReload({

                ...configuration
                    .tableConfig,

                pagination: {

                    perPage,

                    page:
                        1
                }
            });
        };


    /*
     * ========================================================
     * SEARCH
     * ========================================================
     */

    const handlerSearch =
        formData => {

            const tableConfig = {

                ...configuration
                    .tableConfig,

                pagination: {

                    perPage:
                        configuration
                            .tableConfig
                            .pagination
                            .perPage,

                    page:
                        1
                },

                search:
                    formData
            };


            persistAndReload(
                tableConfig
            );
        };


    /*
     * ========================================================
     * REMOVE SEARCH
     * ========================================================
     */

    const handlerSearchRemove =
        () => {

            setIgnoreStatusSelected(
                true
            );


            clearPlantsTableConfig(
                props
            );


            clearPlantsStatusSelected(
                props
            );


            setPlantsFilterCleared(
                props,
                true
            );


            sessionStorage.removeItem(
                getPlantsBadgeStatusStorageKey(
                    props
                )
            );


            navigate(".", {

                replace:
                    true,

                state:
                    {}
            });


            setConfiguration({

                ...configuration,

                disabled:
                    true,

                isLoading:
                    true,

                tableConfig: {

                    ...configuration
                        .tableConfig,

                    pagination: {

                        perPage:
                            configuration
                                .tableConfig
                                .pagination
                                .perPage,

                        page:
                            1
                    },

                    search:
                        {}
                }
            });
        };


    /*
     * ========================================================
     * ROW CLICK
     * ========================================================
     */

    const handlerRowClick =
        (
            row,
            event
        ) => {

            if (deleteMode) {
                return;
            }


            handlerShow(
                row
            );
        };


    /*
     * ========================================================
     * DELETE
     * ========================================================
     */

    const handlerTrash =
        () => {

            setConfiguration({

                ...configuration,

                disabled:
                    true
            });


            if (
                !configuration
                    .isLoading &&
                loadingBarReference
                    .current
            ) {

                loadingBarReference
                    .current
                    .continuousStart();
            }


            deleteUserPlant(

                configuration
                    .modal
                    .selected
                    .id,

                () => {

                    if (
                        loadingBarReference
                            .current
                    ) {

                        loadingBarReference
                            .current
                            .complete();
                    }


                    if (
                        typeof configuration
                            .numberHandler ===
                            "function"
                    ) {

                        configuration
                            .numberHandler();
                    }


                    /*
                     * Después de eliminar seguimos
                     * en MODO ELIMINAR.
                     *
                     * NO borramos seye.deleteMode.
                     */
                    setConfiguration(
                        currentConfiguration => ({

                            ...currentConfiguration,

                            isLoading:
                                true,

                            disabled:
                                true,

                            tableConfig: {

                                ...currentConfiguration
                                    .tableConfig,

                                pagination: {

                                    perPage:
                                        currentConfiguration
                                            .tableConfig
                                            .pagination
                                            .perPage,

                                    page:
                                        1
                                }
                            },

                            modal: {

                                open:
                                    false,

                                selected:
                                    {}
                            }
                        })
                    );
                },

                () => {

                    if (
                        loadingBarReference
                            .current
                    ) {

                        loadingBarReference
                            .current
                            .complete();
                    }


                    setConfiguration(
                        currentConfiguration => ({

                            ...currentConfiguration,

                            rows:
                                [],

                            isLoading:
                                false,

                            disabled:
                                false,

                            message:
                                <DataTableError />,

                            modal: {

                                open:
                                    false,

                                selected:
                                    {}
                            }
                        })
                    );
                }
            );
        };


    /*
     * ========================================================
     * CLOSE DELETE MODAL
     * ========================================================
     */

    const handlerCloseDeleteModal =
        () => {

            setConfiguration({

                ...configuration,

                modal: {

                    ...configuration
                        .modal,

                    open:
                        false,

                    selected:
                        {}
                }
            });
        };


    /*
     * ========================================================
     * OPEN DELETE MODAL
     * ========================================================
     */

    const handlerShowDeleteModal =
        row => {

            if (!deleteMode) {
                return;
            }


            setConfiguration({

                ...configuration,

                modal: {

                    ...configuration
                        .modal,

                    open:
                        true,

                    selected:
                        row
                }
            });
        };


    /*
     * ========================================================
     * COLUMNS
     * ========================================================
     */

    const columns =
        getIndexTableByType(

            {

                ...configuration,

                deleteMode
            },

            {

                showHandler:
                    handlerShow,

                trashHandler:
                    handlerShowDeleteModal
            }
        );


    /*
     * ========================================================
     * TYPE ICON
     * ========================================================
     */

    const icon =
        getIconComponentByCaller(
            props,
            {

                size:
                    20,

                style: {

                    marginRight:
                        "5px"
                }
            }
        );


    /*
     * ========================================================
     * RENDER
     * ========================================================
     */

    return (

        <span
            ref={
                dataTableContainerReference
            }
        >

            <Card
                className={
                    isMobileOnly
                        ? "card-mbl"
                        : ""
                }
            >

                {/*
                 * ====================================================
                 * DESKTOP HEADER
                 * ====================================================
                 */}

                {!isMobileOnly && (

                    <CardHeader
                        className="border-bottom"
                    >

                        <div className="d-flex align-items-center">

                            {icon}

                            <span className="card-title">

                                {t("plants")}

                            </span>

                        </div>

                    </CardHeader>
                )}


                {/*
                 * ====================================================
                 * SEARCH
                 * ====================================================
                 */}

                <CardBody
                    className={
                        `mb-0 pb-0 ${
                            isMobileOnly
                                ? "pt-0"
                                : ""
                        }`
                    }
                    style={
                        isMobileOnly
                            ? {
                                borderBottom:
                                    "1px solid #d9d9d9"
                            }
                            : {}
                    }
                >

                    <SearchPlantForm
                        configuration={
                            configuration
                        }
                        deleteMode={
                            deleteMode
                        }
                        searches={
                            configuration
                                .tableConfig
                                .search
                        }
                        handlerSearch={
                            handlerSearch
                        }
                        handlerSearchRemove={
                            handlerSearchRemove
                        }
                        disabled={
                            configuration
                                .disabled
                        }
                    />

                </CardBody>


                {/*
                 * ====================================================
                 * TABLE
                 * ====================================================
                 */}

                <div
                    className={
                        !isMobileOnly
                            ? "react-dataTable"
                            : "non-class"
                    }
                >

                    <LoadingBar
                        containerClassName="loading-bar-container"
                        className="loading-bar"
                        color="#f11946"
                        ref={
                            loadingBarReference
                        }
                        style={{
                            position:
                                "relative"
                        }}
                    />


                    <DataTable
                        noHeader
                        pagination
                        responsive
                        paginationServer

                        columns={
                            columns
                        }

                        sortIcon={
                            <ChevronDown />
                        }

                        data={
                            configuration
                                .rows
                        }

                        paginationComponentOptions={
                            configuration
                                .paginationOption
                        }

                        onSort={
                            handlerSort
                        }

                        sortServer

                        persistTableHead

                        defaultSortFieldId={
                            3
                        }

                        progressPending={
                            configuration
                                .isLoading
                        }

                        progressComponent={
                            <DataTableLoader />
                        }

                        noDataComponent={
                            configuration
                                .message
                        }

                        disabled={
                            configuration
                                .disabled
                        }

                        paginationTotalRows={
                            configuration
                                .totalRows
                        }

                        onChangeRowsPerPage={
                            handlePerRowsChange
                        }

                        onChangePage={
                            handlePageChange
                        }

                        paginationPerPage={
                            configuration
                                .tableConfig
                                .pagination
                                .perPage
                        }

                        paginationRowsPerPageOptions={
                            defaultPaginationNumber
                        }

                        highlightOnHover={
                            !deleteMode
                        }

                        pointerOnHover={
                            !deleteMode
                        }

                        onRowClicked={
                            handlerRowClick
                        }

                        customStyles={{
                            rows: {

                                style: {
                                    fontSize:
                                        "14px"
                                },

                                highlightOnHoverStyle: {

                                    backgroundColor:
                                        "#f9f9f9",

                                    borderBottomColor:
                                        "#E3E3E3FF",

                                    outlineColor:
                                        "#E3E3E3FF"
                                }
                            },

                            cells: {

                                style: {

                                    wordBreak:
                                        "break-word"
                                }
                            }
                        }}

                        noTableHead={
                            isMobileOnly
                        }

                        paginationDefaultPage={
                            configuration
                                .tableConfig
                                .pagination
                                .page
                        }
                    />


                    {/*
                     * =================================================
                     * MOBILE PAGINATION INFO
                     * =================================================
                     */}

                    {isMobileOnly && (() => {

                        const start =
                            (
                                configuration
                                    .tableConfig
                                    .pagination
                                    .page -
                                1
                            ) *
                            configuration
                                .tableConfig
                                .pagination
                                .perPage;


                        const end =
                            start +
                            configuration
                                .tableConfig
                                .pagination
                                .perPage;


                        return (

                            <div
                                style={{

                                    backgroundColor:
                                        "white",

                                    padding:
                                        "10px 10px",

                                    borderTop:
                                        "1px solid #d9d9d9",

                                    display:
                                        "flex",

                                    flexDirection:
                                        "row",

                                    justifyContent:
                                        "space-between",

                                    alignItems:
                                        "center"
                                }}
                            >

                                <div>

                                    {
                                        i18next.t(
                                            "pagination.page"
                                        )
                                    }:
                                    {" "}
                                    {
                                        configuration
                                            .tableConfig
                                            .pagination
                                            .page
                                    }

                                </div>


                                <div>

                                    {
                                        i18next.t(
                                            "pagination.rows"
                                        )
                                    }

                                    &nbsp;

                                    {start + 1}-

                                    {
                                        end >
                                        configuration
                                            .totalRows
                                            ? configuration
                                                .totalRows
                                            : end
                                    }

                                    &nbsp;

                                    {
                                        i18next.t(
                                            "pagination.page_separator"
                                        )
                                    }

                                    &nbsp;

                                    {
                                        configuration
                                            .totalRows
                                    }

                                </div>

                            </div>
                        );

                    })()}

                </div>


                {/*
                 * ====================================================
                 * DELETE CONFIRMATION MODAL
                 * ====================================================
                 */}

                <Modal
                    isOpen={
                        configuration
                            .modal
                            .open
                    }
                    toggle={
                        handlerCloseDeleteModal
                    }
                >

                    <ModalHeader
                        toggle={
                            handlerCloseDeleteModal
                        }
                    >

                        <div
                            style={{

                                display:
                                    "flex",

                                flexDirection:
                                    "row",

                                alignItems:
                                    "center",

                                alignContent:
                                    "center",

                                justifyContent:
                                    "flex-start"
                            }}
                        >

                            <Trash
                                size="16"
                            />

                            &nbsp;

                            {t("delete")}

                        </div>

                    </ModalHeader>


                    <ModalBody>

                        <div>
                            {t("modals.delete")}
                        </div>

                        <div className="mb-1" />


                        <div
                            style={{
                                fontWeight:
                                    "600"
                            }}
                        >

                            {
                                configuration
                                    .modal
                                    .selected
                                    .plant_name
                            }


                            {
                                configuration
                                    .modal
                                    .selected
                                    .plant_town_name &&
                                (
                                    <>

                                        {" ("}

                                        {
                                            configuration
                                                .modal
                                                .selected
                                                .plant_town_name
                                        }

                                        {")"}

                                    </>
                                )
                            }

                        </div>

                    </ModalBody>


                    <ModalFooter>

                        <Button
                            color="danger"
                            onClick={
                                handlerTrash
                            }
                        >
                            {t("accept")}
                        </Button>


                        <Button
                            color="secondary"
                            onClick={
                                handlerCloseDeleteModal
                            }
                        >
                            {t("cancel")}
                        </Button>

                    </ModalFooter>

                </Modal>


                {
                    configuration
                        .isLoading &&
                    <CardOverlayLoader />
                }

            </Card>

        </span>
    );
}